import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import Modal from 'react-modal';

export const BCAttestationRow = ({
  order,
  onDecline,
  onApprove,
  onDeleteOrderRow,
  isApprover,
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [declineReason, setDeclineReason] = useState('');
  const [rowToDelete, setRowToDelete] = useState(null);

  const name = `${order?.customerInfo?.firstName} ${order?.customerInfo.lastName}`;

  const onChange = (value) => {
    setDeclineReason(value);
  };

  const onlyFreightAndOneProduct = () => {
    const productRows = order.orderRows.filter((row) => row.name !== 'Comment');
    return (
      (productRows.length === 1 && order.freightRow) || productRows.length === 1
    );
  };

  return (
    <>
      <div>
        <div className="BCAttestationRow">
          <div className="BCAttestationRow__item">{order.externalOrderID}</div>
          <div className="BCAttestationRow__item">{order.orderDate}</div>
          <div className="BCAttestationRow__item">{name}</div>
          <div className="BCAttestationRow__item">{order.reference}</div>
          <div className="BCAttestationRow__item">{order.orderGrandTotal}</div>
          <div className="BCAttestationRow__item align-right">
            {isApprover && (
              <>
                <div
                  className="BCAttestationRow__item__icon-button"
                  onClick={() => setShowApproveModal(true)}
                >
                  <i className="BCAttestationRow__item__check-icon" />
                </div>
                <div
                  className="BCAttestationRow__item__icon-button"
                  onClick={() => setShowDeclineModal(true)}
                >
                  <i className="BCAttestationRow__item__delete-icon" />
                </div>
              </>
            )}
            <div className="BCAttestationRow__item__icon-button BCAttestationRow__item__icon-button__group">
              <div className="BCAttestationRow__item__icon-button__seperator"></div>
              <i
                className={`BCAttestationRow__item__arrow-button${
                  isExpanded ? '__open' : ''
                }`}
                onClick={() => setExpanded(!isExpanded)}
              />
            </div>
          </div>
        </div>
        <div>
          <div
            className={`BCAttestationRow__item__dropdown
                                BCAttestationRow__item__dropdown${
                                  isExpanded ? '__active' : '__inactive'
                                }`}
          >
            <div className="BCAttestationRow__item__dropdown__headers">
              <p>{translate('business.attestationtab.dropdown.name')} </p>
              <p>{translate('business.attestationtab.dropdown.price')} </p>
              <p>{translate('business.attestationtab.dropdown.quantity')} </p>
              <p>{translate('business.attestationtab.dropdown.total')} </p>
              <p> </p>
            </div>
            <div className="BCAttestationRow__item__dropdown__row">
              {order.orderRows.map(
                (product, index) =>
                  product.name !== 'Comment' && (
                    <div
                      className="BCAttestationRow__item__dropdown__row__items"
                      key={index}
                    >
                      <p>{product.name}</p>
                      <p>{product.priceInfo.formattedPrice}</p>
                      <p>{product.quantityString}</p>
                      <p>{product.totalPrice}</p>

                      {!onlyFreightAndOneProduct() && isApprover && (
                        <div
                          className="BCAttestationRow__item__icon-button"
                          onClick={() => {
                            if (isApprover) {
                              setRowToDelete({
                                orderId: order.orderId,
                                product,
                                index,
                              });
                              setShowDeleteModal(true);
                            }
                          }}
                        >
                          <i className="BCAttestationRow__item__trash-icon" />
                        </div>
                      )}
                    </div>
                  )
              )}

              {order.freightRow && (
                <div className="BCAttestationRow__item__dropdown__row__items">
                  <p>{order.freightRow.name}</p>
                  <p>{order.freightRow.priceInfo.formattedPrice}</p>
                  <p>{order.freightRow.quantityString}</p>
                  <p>{order.freightRow.totalPrice}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        preventScroll={false}
        isOpen={showDeclineModal}
        onRequestClose={() => setShowDeclineModal(false)}
        shouldCloseOnOverlayClick={false}
        className="BCAttestationRow__modal"
      >
        <h3>{translate('business.attestationtab.modal.decline.title')}</h3>
        <p>
          {translate('business.attestationtab.modal.decline.text')}{' '}
          {order.externalOrderID}
        </p>
        <label htmlFor="attestation-decline-reason">
          {translate('business.attestationtab.modal.decline.input.label')}
        </label>
        <input
          className="form__input"
          id="attestation-decline-reason"
          type="text"
          onChange={(e) => onChange(e.target.value)}
        />
        <div className="BCAttestationRow__modal__buttons">
          <button
            className="BCAttestationRow__modal__buttons__button"
            onClick={() => setShowDeclineModal(false)}
          >
            {translate('business.attestationtab.modal.decline.cancel')}
          </button>
          <button
            className="BCAttestationRow__modal__buttons__button"
            onClick={() => {
              setShowDeclineModal(false);
              onDecline(order, declineReason);
            }}
          >
            {translate('business.attestationtab.modal.decline.confirm')}
          </button>
        </div>
      </Modal>
      <Modal
        ariaHideApp={false}
        preventScroll={false}
        isOpen={showApproveModal}
        onRequestClose={() => setShowApproveModal(false)}
        shouldCloseOnOverlayClick={false}
        className="BCAttestationRow__modal"
      >
        <h3>{translate('business.attestationtab.modal.approve.title')}</h3>
        <p>
          {translate('business.attestationtab.modal.approve.text')}{' '}
          {order.externalOrderID}
        </p>
        <div className="BCAttestationRow__modal__buttons">
          <button
            className="BCAttestationRow__modal__buttons__button"
            onClick={() => setShowApproveModal(false)}
          >
            {translate('business.attestationtab.modal.approve.cancel')}
          </button>
          <button
            className="BCAttestationRow__modal__buttons__button"
            onClick={() => {
              setShowApproveModal(false);
              onApprove(order);
            }}
          >
            {translate('business.attestationtab.modal.approve.confirm')}
          </button>
        </div>
      </Modal>
      <Modal
        ariaHideApp={false}
        preventScroll={false}
        isOpen={showDeleteModal}
        onRequestClose={() => setShowDeleteModal(false)}
        shouldCloseOnOverlayClick={false}
        className="BCAttestationRow__modal"
      >
        <h3>
          {translate('business.attestationtab.modal.delete.title')}{' '}
          {rowToDelete?.product.name}?
        </h3>
        <p>{translate('business.attestationtab.modal.delete.text')} </p>
        <div className="BCAttestationRow__modal__buttons">
          <button
            className="BCAttestationRow__modal__buttons__button"
            onClick={() => setShowDeleteModal(false)}
          >
            {translate('business.attestationtab.modal.delete.cancel')}
          </button>
          <button
            className="BCAttestationRow__modal__buttons__button"
            onClick={() => {
              setShowDeleteModal(false);
              onDeleteOrderRow(rowToDelete.orderId, rowToDelete.index);
              setRowToDelete(null);
            }}
          >
            {translate('business.attestationtab.modal.delete.confirm')}
          </button>
        </div>
      </Modal>
    </>
  );
};
